export const states = {
  us: [
    { name: '', value: '' },
    { name: 'Alabama', value: 'AL' },
    { name: 'Alaska', value: 'AK' },
    { name: 'Arizona', value: 'AZ' },
    { name: 'Arkansas', value: 'AR' },
    { name: 'Armed Forces Americas', value: 'AA' },
    { name: 'Armed Forces Europe', value: 'AE' },
    { name: 'Armed Forces Pacific', value: 'AP' },
    { name: 'California', value: 'CA' },
    { name: 'Colorado', value: 'CO' },
    { name: 'Connecticut', value: 'CT' },
    { name: 'Delaware', value: 'DE' },
    { name: 'District of Columbia', value: 'DC' },
    { name: 'Florida', value: 'FL' },
    { name: 'Georgia', value: 'GA' },
    { name: 'Hawaii', value: 'HI' },
    { name: 'Idaho', value: 'ID' },
    { name: 'Illinois', value: 'IL' },
    { name: 'Indiana', value: 'IN' },
    { name: 'Iowa', value: 'IA' },
    { name: 'Kansas', value: 'KS' },
    { name: 'Kentucky', value: 'KY' },
    { name: 'Louisiana', value: 'LA' },
    { name: 'Maine', value: 'ME' },
    { name: 'Maryland', value: 'MD' },
    { name: 'Massachusetts', value: 'MA' },
    { name: 'Michigan', value: 'MI' },
    { name: 'Minnesota', value: 'MN' },
    { name: 'Mississippi', value: 'MS' },
    { name: 'Missouri', value: 'MO' },
    { name: 'Montana', value: 'MT' },
    { name: 'Nebraska', value: 'NE' },
    { name: 'Nevada', value: 'NV' },
    { name: 'New Hampshire', value: 'NH' },
    { name: 'New Jersey', value: 'NJ' },
    { name: 'New Mexico', value: 'NM' },
    { name: 'New York', value: 'NY' },
    { name: 'North Carolina', value: 'NC' },
    { name: 'North Dakota', value: 'ND' },
    { name: 'Ohio', value: 'OH' },
    { name: 'Oklahoma', value: 'OK' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Pennsylvania', value: 'PA' },
    { name: 'Puerto Rico', value: 'PR' },
    { name: 'Rhode Island', value: 'RI' },
    { name: 'South Carolina', value: 'SC' },
    { name: 'South Dakota', value: 'SD' },
    { name: 'Tennessee', value: 'TN' },
    { name: 'Texas', value: 'TX' },
    { name: 'Utah', value: 'UT' },
    { name: 'Vermont', value: 'VT' },
    { name: 'Virginia', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'West Virginia', value: 'WV' },
    { name: 'Wisconsin', value: 'WI' },
    { name: 'Wyoming', value: 'WY' },
  ],
  china: [
    { name: '', value: '' },
    { name: 'Heilongjiang Province', value: 'Heilongjiang Province' },
    { name: 'Jilin Province', value: 'Jilin Province' },
    { name: 'Liaoning Province', value: 'Liaoning Province' },
    { name: 'Neimenggu A. R.', value: 'Neimenggu A. R.' },
    { name: 'Gansu Province', value: 'Gansu Province' },
    { name: 'Ningxia A. R.', value: 'Ningxia A. R.' },
    { name: 'Xinjiang A. R.', value: 'Xinjiang A. R.' },
    { name: 'Qinghai Province', value: 'Qinghai Province' },
    { name: 'Hebei Province', value: 'Hebei Province' },
    { name: 'Henan Province', value: 'Henan Province' },
    { name: 'Shandong Province', value: 'Shandong Province' },
    { name: 'Shanxi Province', value: 'Shanxi Province' },
    { name: 'Shaanxi Province', value: 'Shaanxi Province' },
    { name: 'Jiangsu Province', value: 'Jiangsu Province' },
    { name: 'Zhejiang Province', value: 'Zhejiang Province' },
    { name: 'Anhui Province', value: 'Anhui Province' },
    { name: 'Hubei Province', value: 'Hubei Province' },
    { name: 'Hunan Province', value: 'Hunan Province' },
    { name: 'Sichuan Province', value: 'Sichuan Province' },
    { name: 'Guizhou Province', value: 'Guizhou Province' },
    { name: 'Jiangxi Province', value: 'Jiangxi Province' },
    { name: 'Guangdong Province', value: 'Guangdong Province' },
    { name: 'Guangxi A. R.', value: 'Guangxi A. R.' },
    { name: 'Yunnan Province', value: 'Yunnan Province' },
    { name: 'Hainan Province', value: 'Hainan Province' },
    { name: 'Xizang A. R.', value: 'Xizang A. R.' },
    { name: 'Beijing', value: 'Beijing' },
    { name: 'Shanghai', value: 'Shanghai' },
    { name: 'Tianjin', value: 'Tianjin' },
    { name: 'Chongqing', value: 'Chongqing' },
    { name: 'Fujian Province', value: 'Fujian Province' },
  ],
  japan: [
    { name: '', value: '' },
    { name: 'Hokkaidō', value: 'Hokkaidō' },
    { name: 'Aomori', value: 'Aomori' },
    { name: 'Iwate', value: 'Iwate' },
    { name: 'Miyagi', value: 'Miyagi' },
    { name: 'Akita', value: 'Akita' },
    { name: 'Yamagata', value: 'Yamagata' },
    { name: 'Fukushima', value: 'Fukushima' },
    { name: 'Ibaraki', value: 'Ibaraki' },
    { name: 'Tochigi', value: 'Tochigi' },
    { name: 'Gunma', value: 'Gunma' },
    { name: 'Saitama', value: 'Saitama' },
    { name: 'Chiba', value: 'Chiba' },
    { name: 'Tokyo', value: 'Tokyo' },
    { name: 'Kanagawa', value: 'Kanagawa' },
    { name: 'Niigata', value: 'Niigata' },
    { name: 'Toyama', value: 'Toyama' },
    { name: 'Ishikawa', value: 'Ishikawa' },
    { name: 'Fukui', value: 'Fukui' },
    { name: 'Yamanashi', value: 'Yamanashi' },
    { name: 'Nagano', value: 'Nagano' },
    { name: 'Gifu', value: 'Gifu' },
    { name: 'Shizuoka', value: 'Shizuoka' },
    { name: 'Aichi', value: 'Aichi' },
    { name: 'Mie', value: 'Mie' },
    { name: 'Shiga', value: 'Shiga' },
    { name: 'Kyoto', value: 'Kyoto' },
    { name: 'Osaka', value: 'Osaka' },
    { name: 'Hyōgo', value: 'Hyōgo' },
    { name: 'Nara', value: 'Nara' },
    { name: 'Wakayama', value: 'Wakayama' },
    { name: 'Tottori', value: 'Tottori' },
    { name: 'Shimane', value: 'Shimane' },
    { name: 'Okayama', value: 'Okayama' },
    { name: 'Hiroshima', value: 'Hiroshima' },
    { name: 'Yamaguchi', value: 'Yamaguchi' },
    { name: 'Tokushima', value: 'Tokushima' },
    { name: 'Kagawa', value: 'Kagawa' },
    { name: 'Ehime', value: 'Ehime' },
    { name: 'Kochi', value: 'Kochi' },
    { name: 'Fukuoka', value: 'Fukuoka' },
    { name: 'Saga', value: 'Saga' },
    { name: 'Nagasaki', value: 'Nagasaki' },
    { name: 'Kumamoto', value: 'Kumamoto' },
    { name: 'Ōita', value: 'Ōita' },
    { name: 'Miyazaki', value: 'Miyazaki' },
    { name: 'Kagoshima', value: 'Kagoshima' },
    { name: 'Okinawa', value: 'Okinawa' },
  ],
};

export const countriesStates = {
  US: states.us,
  JP: states.japan,
  CN: states.china,
};

export const defaultStates = states.us;

export default states;
